import { apiSlice } from "../../apiSlice";

export const inventorySparesPriority = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInventorySparesPriority: builder.query({
      query: () => "inventory/spares/priority",
      transformResponse: (response) => {
        return {
          seller: response?.data?.seller ?? "",
          lotId: response?.data?.lot_id ?? "",
        };
      },
    }),
  }),
});

export const {
  useGetInventorySparesPriorityQuery,
} = inventorySparesPriority;
